import { AlertInline } from '@storeblocks/inline-alert';
import { type FC } from 'react';

import { FundInfo } from './FundInfo';

interface Props {
  errorMessage: string;
  isin: string;
}

export const AmountError: FC<Props> = ({ errorMessage, isin }) => {
  return (
    <FundInfo>
      <AlertInline
        data-test={`amount-error-${isin}`}
        title={errorMessage}
        variant="error"
      />
    </FundInfo>
  );
};
